import React from "react";
import LogIn from "../auth/Login";
import SignUp from "../auth/SignUp";
import LogOut from "../auth/LogOut";
import { Link } from "react-router-dom";
import "./header.css";

function Header(props) {
	return (
		<header className="Header">
			{/* HEADER DIV LEFT*/}
			<div className="header-sub-div header-sub-div-left">
				{/* HEADER H1 LOGO LINK*/}
				<Link className="header-nav-link" to="/">
					<i class="fas fa-circle"></i>
					<h1>bkz-src</h1>
				</Link>

				{/* BROWSE */}
				<Link className="header-nav-link" to="/browse">
					Browse
				</Link>

				{/* ABOUT */}
				<Link className="header-nav-link" to="/about">
					About
				</Link>
			</div>

			{/* HEADER DIV RIGHT */}
			<div className="header-sub-div header-sub-div-right">
				{/* VERIFICATION FORM */}

				{/* HEADER LOGOUT OR LOGIN/SIGN UP*/}
				{props.user ? (
					<>
						<LogOut setUser={props.setUser} />
					</>
				) : (
					<>
						<LogIn
							setUser={props.setUser}
							fetchFirebase={props.fetchFirebase}
						/>
						<SignUp
							setUser={props.setUser}
							fetchFirebase={props.fetchFirebase}
						/>
					</>
				)}
			</div>
		</header>
	);
}

export default Header;
